// Display-only localisation of cycle labels. Stored period names are never changed.
// "Q1 2026" → "T1 2026" in French (trimestre); "Quarter 2" → "Trimestre 2".
export function localizePeriodLabel(label, language) {
    if (label == null) return label;
    const text = String(label);
    if (language !== "fr") return text;
    return text
        .replace(/\bQ([1-4])(?=\b|\s|-|$)/g, "T$1")
        .replace(/\bQuarter\s+([1-4])\b/gi, "Trimestre $1");
}
